import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SELECTED_NAV_OPTION } from "../constants/stringConstants";

interface CommonState {
  selectedNavbarOption: string;
}

const initialState: CommonState = {
  selectedNavbarOption: sessionStorage.getItem("selectedNavbarOption") || SELECTED_NAV_OPTION.JOBS,
};

// reducers -> reduce to a specific state -> changes state
export const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setNavOption: (state, actions: PayloadAction<any>) => {
      if (actions.payload) {
        state.selectedNavbarOption = actions.payload;
        sessionStorage.setItem("selectedNavbarOption", actions.payload);

      }
    },
    reset: () => initialState,
  },
});

export const { setNavOption, reset } = commonSlice.actions;

export default commonSlice.reducer;
